import React from "react";
import clsx from "clsx";

import { type SortOption } from "~/providers/NostoProvider";

import { AccordionAnimation } from "~/components/Accordion/AccordionAnimation";

import { FormRadio, IconChevron } from "@bared/ui";

type SortProps = {
  sortOption: SortOption;
  sortOptions: SortOption[];
  setSortOption: (sortOption: SortOption) => void;
  show: boolean;
  handleSectionToggle: () => void;
};

export const Sort = ({
  sortOption,
  sortOptions,
  setSortOption,
  show,
  handleSectionToggle,
}: SortProps) => {
  const currentValue = sortOption.label.toLowerCase();

  return (
    <div className={clsx(show && "border-b", "w-full overflow-hidden")}>
      <div
        className="transition-presentation flex w-full items-center justify-start border-b hover:text-secondary"
        onClick={handleSectionToggle}
      >
        <button className="grow px-mini py-maxi text-left">
          Sort By: {sortOption.label}
        </button>
        <IconChevron
          className={clsx(
            show && "rotate-180",
            "mx-mini mt-pico w-[12px] transform transform-gpu",
          )}
        />
      </div>
      <AccordionAnimation active={show}>
        <FormRadio
          className="gap-mini p-midi"
          name="sort"
          orientation="col"
          value={currentValue}
          options={sortOptions.map((option) => ({
            value: option.label.toLowerCase(),
            label: option.label,
          }))}
          onChange={(value) => {
            const selected = sortOptions.find(
              (option) => option.label.toLowerCase() === value,
            );
            if (selected) {
              setSortOption(selected);
            }
          }}
        />
      </AccordionAnimation>
    </div>
  );
};
